import { Table, Tooltip } from "antd";

// Таблица рабочих групп типа заявки
const RequestAccessUnitsTable = ({
  data = [],
  loading,
}) => {
  const columns = [
    {
      title: "Рабочая группа",
      dataIndex: "name",
      key: "name",
      width: 250,
      ellipsis: { showTitle: false },
      render: (_, item) => (
        <Tooltip placement="bottomLeft" title={item.name}>
          {item.name}
        </Tooltip>
      ),
    },
  ];

  return (
    <Table
      dataSource={data}
      columns={columns}
      rowKey="uuid"
      loading={loading}
      pagination={false}
      // onChange={onChange}
      size="small"
      scroll={{ x: "100%" }}
    />
  );
};

export default RequestAccessUnitsTable;
